import pick from 'lodash/pick'
import FullTable from 'js/components/full-table/index.js'
import AnalyticsUtils from 'js/services/analytics-utils'
import {mapGetters} from 'vuex'

import template from './_table.pug'

export default Vue.extend({
  template: template(),
  components: {
    FullTable
  },
  props: {
    leads: {
      type: Array,
      required: true
    },
    dataCountTotal: {
      type: Array,
      required: true
    },
    totalQuantity: {
      type: Number,
      required: true
    },
    totalPercentage: {
      type: Number,
      required: true
    },
    providers: {
      type: Array,
      required: true
    },
    head: {
      type: Array,
      required: true
    },
    campaigns: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      modalExport: false,
      dateConfig: {
        dateFormat: 'd/m/Y',
        allowInvalidPreload: true,
        enableTime: false
      },
      showFilters: true,
      // eslint-disable-next-line max-len
      filters: {from: '', to: '', providerLeadId: '', campaignId: '', format: 'pdf'},
      lastQueryOptions: null, // guarda los últimos filtros aplicados
      errorsMapping: {
        fromDate: '',
        toDate: '',
        errores: 0
      },
      exportOptions: [
        {label: 'Excel', value: 'excel'},
        {label: 'PDF', value: 'pdf'}
      ],
      firstLoad: true,
      clear: false
    }
  },
  computed: {
    ...mapGetters(['errorTypes']),
    fromDateConfig() {
      return {
        ...this.dateConfig
      }
    },
    toDateConfig() {
      return {
        ...this.dateConfig
      }
    },

    defaultOrder() {
      return {currentField: 'fullname', currentDir: 'asc'}
    },

    filterButtonParams() {
      if (this.showFilters) {
        return {class: 'active', icon: 'angle-up'}
      }

      return {class: '', icon: 'angle-down'}
    },
    campaignsOptions() {
      return this.campaigns.map(campaign => ({
        label: campaign.name,
        value: campaign.id
      }))
    },
    nsFieldFrom() {
      return this.errorsMapping.fromDate
    },
    nsFieldTo() {
      return this.errorsMapping.toDate
    },
    providersOptions() {
      return this.providers.map(item => ({
        label: item.name,
        value: item.id
      }))
    }
  },
  methods: {

    switchModal() {
      if (this.modalExport) {
        this.modalExport = false
      } else {
        this.modalExport = true
      }
    },

    getData(queryOptions) {
      if (this.firstLoad) {
        this.firstLoad = false
      } else {
        if (this.firstLoad === false &&
          this.clear === true &&
          this.$refs.filterTable.appliedFilters === false) {
          this.errorsMapping = {
            fromDate: '',
            toDate: '',
            errores: 0
          }
          this.clear = false
          this.$parent.leads = []
        } else {
          this.errorsMapping = this.checkFilters(queryOptions)
          if ('filter' in queryOptions) {
            queryOptions = this.formatFilters(queryOptions)
          }
          if (this.errorsMapping.errores === 0) {
            this.$emit('load-data', queryOptions || this.lastQueryOptions)
            this.clear = true
          }
        }

        if (queryOptions) this.lastQueryOptions = queryOptions
      }
    },
    checkFilters(data) {
      const error = {}
      let errores = 0
      if ('filter' in data) {
        if ('from' in data.filter) {
          error.fromDate = ''
        } else {
          errores += 1
          error.fromDate = this.$t('errors.blank')
        }
        if ('to' in data.filter) {
          error.toDate = ''
        } else {
          errores += 1
          error.toDate = this.$t('errors.blank')
        }
      } else {
        errores = 2
        error.fromDate = this.$t('errors.blank')
        error.toDate = this.$t('errors.blank')
      }
      error.errores = errores
      return error
    },
    t(key, options = {}) {
      return this.$t(`customers.index.${key}`, options)
    },
    l(key, options = {}) {
      return this.$t(`tipificationReport.${key}`, options)
    },
    exportLeads() {
      // eslint-disable-next-line max-len
      let queryOptions = this.$refs.filterTable.filterData.to && this.$refs.filterTable.filterData.to ? {filter: this.$refs.filterTable.filterData} : {filter: {}}
      // eslint-disable-next-line eqeqeq
      if (this.filters.format != '') {
        queryOptions.filter.format = this.filters.format
      }
      if ('filter' in queryOptions) {
        queryOptions = this.formatFilters(queryOptions)
        // eslint-disable-next-line eqeqeq
        if (this.filters.format != '') {
          queryOptions.filter.format = this.filters.format
        } else {
          queryOptions.filter.format = ''
        }
      }
      this.errorsMapping = this.checkFilters(queryOptions)
      if (this.errorsMapping.errores === 0) {
        API.tipificationReport
          .exportTipificationReport(queryOptions)
          .then(({data}) => {
            AnalyticsUtils.downloadCsv({
              title: this.l('exportCsv.title'),
              to: queryOptions.to,
              from: queryOptions.from,
              url: data.file
            })
            this.modalExport = false
          })
      }
    },
    formatFilters(data) {
      const newData = pick(data, [
        'order',
        'page'
      ])
      if ('filter' in data) {
        newData.filter = {}
        if ('from' in data.filter) {
          newData.filter.from = moment(data.filter.from).format(FORMAT_DATE)
        }
        if ('to' in data.filter) {
          newData.filter.to = moment(data.filter.to).format(FORMAT_DATE)
        }
        if ('providerLeadId' in data.filter) {
          if (data.filter.providerLeadId !== '') {
            newData.filter.providerLeadId = data.filter.providerLeadId
          }
        }
        if ('campaignId' in data.filter) {
          if (data.filter.campaignId !== '') {
            newData.filter.campaignId = data.filter.campaignId
          }
        }
      }
      return newData
    },
    loadLeadsCsv() {
      // Este solo se ve afectado por estos filtros
      const filters = {}
      if ('filter' in this.filters) {
        filters.filter = pick(this.filters.filter, [
          'from',
          'to'
        ])
      }
      API.accounts
        .exportTipificationReport(filters)
        .then(({data}) => {
          AnalyticsUtils.downloadCsv({
            title: this.l('exportCsv.title'),
            to: filters.to,
            from: filters.from,
            url: data.file
          })
        })
    }
  }
})
